import { ChatMessageData } from '../../../../generated/api';

export enum SocketEvent {
  NewMsg = 'private.message',
}

export type SocketEventArgs = {
  [SocketEvent.NewMsg]: ChatMessageData;
};
